import store from '@/store';
export default {
  // benchmarkMenu: [
  //   { name: 'Gemeente', target: 'getMunicipalityOptions' },
  //   { name: 'Netbeheerder', target: 'gridOperators' },
  //   { name: 'Type realisatieproces', target: 'getCategoryOptions' },
  //   { name: 'Aantal palen per RP', target: 'recordsByNumberOfChargingStations' }
  // ],

  LocationPickerDiameter: 250,

  chargePointOperatorField: {
    type: 'string',
    title: 'CPO',
    format: 'select',
    get options () { return store.getters['tenant/getCpos'] },
    disabled: false,
    placeholder: 'Selecteer CPO'
  },

  supportEmailAddress: 'support@evtools.nl'
};
